var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.325 22.4999C12.1536 22.4993 11.9842 22.4635 11.8272 22.3947C11.6702 22.3259 11.5291 22.2256 11.4125 22.0999L5.33752 15.6374C5.11042 15.3954 4.98877 15.0731 4.99932 14.7414C5.00987 14.4097 5.15176 14.0957 5.39377 13.8686C5.63578 13.6415 5.95809 13.5199 6.28979 13.5304C6.6215 13.541 6.93542 13.6829 7.16252 13.9249L12.3125 19.4124L22.825 7.91239C22.9317 7.77954 23.0644 7.66991 23.215 7.59022C23.3656 7.51053 23.5309 7.46247 23.7008 7.44899C23.8706 7.43551 24.0414 7.45689 24.2027 7.51183C24.364 7.56676 24.5123 7.65409 24.6386 7.76845C24.7649 7.8828 24.8665 8.02177 24.9372 8.17682C25.0078 8.33186 25.046 8.49971 25.0494 8.67006C25.0528 8.84041 25.0214 9.00965 24.957 9.1674C24.8926 9.32515 24.7966 9.46807 24.675 9.58739L13.25 22.0874C13.1346 22.2153 12.9939 22.318 12.8369 22.389C12.6798 22.46 12.5098 22.4977 12.3375 22.4999H12.325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8cabe883.svg";
export { ForwardRef as ReactComponent };